import { SvgIcon, SvgIconProps } from '@mui/material';
import React, { ReactElement } from 'react';

export interface DownloadIconProps extends SvgIconProps {}

export const DownloadIcon = ({
  style,
  ...iconProps
}: DownloadIconProps): ReactElement => {
  style = {
    fontSize: '1em',
    ...style,
  };

  return (
    <SvgIcon style={style} {...iconProps} viewBox="0 0 20.444 20.444">
      <g transform="translate(1 1)">
        <path
          d="M22.944,22.5v4.1a2.049,2.049,0,0,1-2.049,2.049H6.549A2.049,2.049,0,0,1,4.5,26.6V22.5"
          transform="translate(-4.5 -10.204)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M10.5,15l5.123,5.123L20.747,15"
          transform="translate(-6.401 -7.827)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M18,16.8V4.5"
          transform="translate(-8.778 -4.5)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
    </SvgIcon>
  );
};
